/*
 * Protectia coletului in cos.
 *
 * Pornita din start: daca in cos exista alte produse si omul nu a stins-o niciodata,
 * se adauga singura. Refuzul se tine in localStorage, altfel ar reveni la fiecare
 * reincarcare a cosului si ar arata ca o pacaleala.
 *
 * Ascultatorul e delegat de pe document: Dawn rescrie tot interiorul sertarului la
 * fiecare modificare a cosului, deci un handler legat direct pe buton s-ar pierde.
 */
(function () {
  if (window.__nkShipProtectInit) return;
  window.__nkShipProtectInit = true;

  var OPT_OUT = 'nk_shipping_protection_off';
  var busy = false;
  var selfRemoving = false;   // noi am scos-o (cos golit), nu clientul
  var wasPresent = null;      // era in cos la ultima verificare?

  function optedOut() {
    try { return localStorage.getItem(OPT_OUT) === '1'; } catch (e) { return false; }
  }
  function setOptOut(v) {
    try { v ? localStorage.setItem(OPT_OUT, '1') : localStorage.removeItem(OPT_OUT); } catch (e) {}
  }

  /* Steagul se stinge pe ambele drumuri, si pe reusita si pe esec. Daca ramane aprins,
     scriptul crede ca noi scoatem garantia si nu mai tine minte refuzul clientului. */
  function clearSelfRemoving() {
    wasPresent = false;
    selfRemoving = false;
  }

  function variantId() {
    var row = document.querySelector('[data-nk-sp]');
    return row ? Number(row.getAttribute('data-variant')) : 0;
  }

  /*
   * Daca garantia era in cos si dintr-o data nu mai e, iar disparitia nu vine de la noi,
   * inseamna ca omul a sters linia din cos. Aia e tot o refuzare, la fel ca stingerea
   * intrerupatorului, si trebuie tinuta minte. Fara asta o adaugam la loc la urmatoarea
   * modificare a cosului si ii calcam decizia in picioare.
   */
  function syncPresence() {
    var id = variantId();
    if (!id) return Promise.resolve();
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var present = cart.items.some(function (i) { return i.variant_id === id; });
        /* Disparitia conteaza ca refuz doar daca in cos au ramas produse: atunci omul
           a scos anume garantia. Daca s-a golit tot cosul, nu e un refuz, e o golire,
           si nu avem dreptul sa i-o tinem minte ca pe o decizie. */
        var otherPaid = cart.items.some(function (i) { return i.variant_id !== id && i.price > 0; });
        if (wasPresent === true && present === false && !selfRemoving && otherPaid) setOptOut(true);
        wasPresent = present;
        return cart;
      })
      .catch(function () {});
  }

  function refreshCart() {
    // reincarcam sertarul ca sa se vada totalul nou
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) { window.location.reload(); return; }
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('cart-drawer');
        var live = document.querySelector('cart-drawer');
        if (fresh && live) {
          live.innerHTML = fresh.innerHTML;
          /* Doar is-empty. Copierea intregului className stergea "active", clasa
             cu care Dawn tine sertarul deschis, si sertarul disparea. */
          live.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
          var fi = fresh.querySelector('cart-drawer-items');
          var li = live.querySelector('cart-drawer-items');
          if (fi && li) li.className = fi.className;
        }
        var fb = parsed.querySelector('#cart-icon-bubble');
        var lb = document.querySelector('#cart-icon-bubble');
        if (fb && lb) lb.innerHTML = fb.innerHTML;
      })
      .catch(function () {});
  }

  function setProtection(variantId, on) {
    if (busy) return Promise.resolve();
    busy = true;
    var body = on
      ? { items: [{ id: variantId, quantity: 1 }] }
      : { updates: {} };
    if (!on) body.updates[variantId] = 0;

    return fetch(on ? '/cart/add.js' : '/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function () { return refreshCart(); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  // pornire automata, o singura data per stare de cos
  function autoAdd() {
    var row = document.querySelector('[data-nk-sp]');
    if (!row || optedOut()) return;
    // in tarile care nu permit prebifarea, randul apare stins si nu adaugam nimic
    if (row.getAttribute('data-default-on') !== 'true') return;
    var variantId = Number(row.getAttribute('data-variant'));
    if (!variantId) return;
    if (row.getAttribute('data-on') === 'true') return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var others = cart.items.filter(function (i) { return i.variant_id !== variantId; });
        // nu adaugam protectie pe un cos gol: n-ar avea ce proteja
        if (!others.length) return;
        var has = cart.items.some(function (i) { return i.variant_id === variantId; });
        if (!has) setProtection(variantId, true);
      })
      .catch(function () {});
  }

  /*
   * Garantia nu are ce sa acopere daca in cos nu mai e niciun produs platit.
   * Fara curatenia asta, stergerea ultimului produs lasa in cos doar linia de
   * garantie: cosul nu era gol, deci nu aparea nici mesajul de cos gol, nici
   * butonul de intors la magazin. Exact bug-ul raportat.
   */
  function cleanupOrphan() {
    var row = document.querySelector('[data-nk-sp]');
    var variantId = row ? Number(row.getAttribute('data-variant')) : 0;
    if (!variantId) return Promise.resolve();

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasWarranty = cart.items.some(function (i) { return i.variant_id === variantId; });
        if (!hasWarranty) return null;
        // produs real = ceva cu pret, care nu e garantia si nu e un cadou de 0
        var hasRealProduct = cart.items.some(function (i) {
          return i.variant_id !== variantId && i.price > 0;
        });
        if (hasRealProduct) return null;
        var updates = {};
        updates[variantId] = 0;
        selfRemoving = true;    // golirea cosului nu e o refuzare a clientului
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(refreshCart).then(clearSelfRemoving, clearSelfRemoving);
      })
      .catch(function () {});
  }

  // orice scriere in cos poate lasa garantia orfana, deci verificam dupa fiecare
  var WRITES = /\/cart\/(add|change|update|clear)(\.js)?/;
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (url && url.url) url = url.url;
    var isWrite = typeof url === 'string' && WRITES.test(url);
    var p = origFetch.apply(this, arguments);
    if (isWrite && !busy) {
      p.then(function () {
        /* si autoAdd: altfel garantia aparea abia la urmatoarea incarcare de pagina,
           nu cand omul apasa Add to Cart. */
        setTimeout(function () { syncPresence().then(cleanupOrphan).then(autoAdd); }, 220);
      }).catch(function () {});
    }
    return p;
  };

  /* X-ul din randul de garantie face exact ce face intrerupatorul: scoate din cos
     si tine minte refuzul, ca sa nu revina la urmatoarea modificare a cosului. */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-nk-warranty-remove]');
    if (rm) {
      e.preventDefault();
      var id = variantId();
      if (!id) return;
      setOptOut(true);
      wasPresent = false;
      var sw = document.querySelector('[data-nk-sp-toggle]');
      if (sw) { sw.classList.remove('is-on'); sw.setAttribute('aria-checked', 'false'); }
      setProtection(id, false);
      return;
    }
  });

  /* X-ul lui Dawn de pe randul garantiei, oriunde ar fi randul (cos mare sau sertar):
     e o refuzare explicita si se tine minte pe loc, fara sa mai fie dedusa dupa. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('cart-remove-button, .cart-remove-button');
    if (!btn) return;
    var id = variantId();
    if (!id) return;
    var row = btn.closest('[data-nk-variant]');
    if (!row || row.getAttribute('data-nk-variant') !== String(id)) return;
    setOptOut(true);
    wasPresent = false;
    var sw = document.querySelector('[data-nk-sp-toggle]');
    if (sw) { sw.classList.remove('is-on'); sw.setAttribute('aria-checked', 'false'); }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nk-sp-toggle]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-nk-sp]');
    if (!row) return;
    var variantId = Number(row.getAttribute('data-variant'));
    if (!variantId) return;

    var turningOn = !btn.classList.contains('is-on');
    btn.classList.toggle('is-on', turningOn);
    btn.setAttribute('aria-checked', turningOn ? 'true' : 'false');
    btn.setAttribute('disabled', 'disabled');

    setOptOut(!turningOn);
    wasPresent = turningOn;      // stim deja rezultatul, nu-l mai interpretam ca refuz separat
    setProtection(variantId, turningOn);
  });

  function boot() { syncPresence().then(autoAdd); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('nk:gifts-updated', function () { autoAdd(); cleanupOrphan(); });
})();
